import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { useState, useEffect } from "react";
import TablaTickets from "./TablaTickets"
import TicketPerfil from "./TicketPerfil";
import { axiosInstance } from "../../components/helpers/axiosInstance";
import ToastNotificacion from "../../components/notificaciones/ToastNotificacion"
import logo from '../../assets/media/logos/fiducia/fd-isotipo-color.svg'
export default function Ticket() {
    const [tabs, setTabs] = useState([]);
    const [tabsId, setTabsId] = useState("home");
    const [tickets, setTickets] = useState([]);

    useEffect(() => {
        axiosInstance.get('/tickets')
            .then(res => {
                setTickets(res.data.tickets);
            })
            .catch(error => console.error(error));
    }, []);

    function deleteTab(e, id){
        e.stopPropagation();
        setTabs(tabs.filter(t => t.id_ticket !== Number(id)));
        setTabsId("home");
    }

    function toggleShow(e, id, title){
        e.stopPropagation();
        const exist = tabs.some(t => t.id_ticket === id);
        setTabsId(id);
        if (!exist) {
            setTabs( prevState => [
                ...prevState, {
                    id_ticket :  id,
                    ticket : title
                }
            ])
        }
    }

    return (
        <>
            <style type='text/css'>
                {`
                    @media (max-width: 767.98px) {
                        .nav-item .nav-link i:before {
                            margin-top: -8px!important;
                        }
                        .nav-item .nav-link span:before {
                            margin-top: -8px!important;
                        }
                    }

                    .nav-tabs-fiducia {
                        position : sticky;
                        top : 5.769230769rem;
                        z-index : 7;
                    }
                    
                    @media (max-width: 991.98px) {
                        .nav-tabs-fiducia {
                            position : sticky;
                            top : 4.615384615rem;
                            z-index : 7;
                        }
                    }
                `}
            </style>

            <ToastNotificacion></ToastNotificacion>
            <Tabs
                className={"nav-tabs-fiducia"}
                defaultActiveKey={"home"}
                transition={false}
                activeKey={tabsId}
                onSelect={(key, event) => {
                    event.stopPropagation();
                    setTabsId(key);
                }}
            >
                <Tab title={<>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         className="bi bi-list-ul me-1" viewBox="0 0 16 16">
                        <path fillRule="evenodd"
                              d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                    </svg>
                    Tickets <span></span>
                    </>}
                     eventKey={"home"}
                >
                    {
                        tickets && tickets.length > 0 ? (
                            <div className={'px-4'}>
                                <TablaTickets toggleShow={toggleShow} tickets={tickets}></TablaTickets>
                            </div>
                        ) : (
                            <div className="position-relative flex-column" style={{height: "10rem"}}>
                                <img alt="Logo" className="h-45px position-absolute top-50 start-50 translate-middle"
                                     src={logo}/>
                                <div className="d-flex align-items-center mt-1 position-absolute bottom-0 start-50 translate-middle-x">
                                    <span className="spinner-border text-primary" role="status"></span>
                                    <span className="text-muted fs-6 fw-semibold ms-5">Cargando...</span>
                                </div>
                            </div>
                        )
                    }
                </Tab>
                {
                    tabs && tabs.length > 0 && tabs.map((t) => {
                        return (
                            <Tab key={t.id_ticket} title={<>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     className="bi bi-ticket-perforated me-1" viewBox="0 0 16 16">
                                    <path
                                        d="M4 4.85v.9h1v-.9zm7 0v.9h1v-.9zm-7 1.8v.9h1v-.9zm7 0v.9h1v-.9zm-7 1.8v.9h1v-.9zm7 0v.9h1v-.9zm-7 1.8v.9h1v-.9zm7 0v.9h1v-.9z"/>
                                    <path
                                        d="M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3zM1 4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1.05a2.5 2.5 0 0 0 0 4.9v1.05a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1.05a2.5 2.5 0 0 0 0-4.9z"/>
                                </svg>
                                {t.ticket} <i onClick={(e) => deleteTab(e, t.id_ticket)}></i>
                            </>}
                                 eventKey={t.id_ticket}
                            >
                                <div className={'px-4'}>
                                    <TicketPerfil data={t.id_ticket}></TicketPerfil>
                                </div>
                            </Tab>
                        );
                    })
                }
            </Tabs>
        </>
    );
}
